@if (content && exercisePerformance | async; as exercisePerformance) {
  <section class="col-8 mx-auto text-center">
    <header>
      <h1>{{content.headline}}</h1>
    </header>
    <div class="row">
      <div class="col-4 mx-auto">
        <div class="jumbotron">
          <h3 class="display-3">{{exercisePerformance.percentCorrect.toFixed() + '%'}}</h3>
          <h4>
            Accuracy<br>
            <i class="fa fa-bullseye"></i>
          </h4>
        </div>
      </div>
    </div>
    <p class="lead">{{content.copy}}</p>
    <div class="row">
      @if (exercisePerformance.percentCorrect < 100) {
        <div class="col-4 offset-2">
          <button class="btn btn-success btn-lg btn-block" (click)="onPersistedRound()">{{content.startRoundButtonText}}</button>
        </div>
      }
      <div [ngClass]="exercisePerformance.percentCorrect < 100 ? 'col-4' : 'col-4 offset-4'">
        <a class="btn btn-primary btn-lg btn-block" (click)="onEndExercise()">{{content.endExerciseButtonText}}</a>
      </div>
    </div>
  </section>
} @else {
  <app-spinner></app-spinner>
}
